import { render, staticRenderFns } from "./Imageset.vue?vue&type=template&id=2b148000&lang=pug&"
import script from "./Imageset.vue?vue&type=script&lang=js&"
export * from "./Imageset.vue?vue&type=script&lang=js&"
import style0 from "./Imageset.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports